import { attr, belongsTo } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const Addon = ApplicationRecord.extend({
  static: {
    jsonapiType: 'addons',
  },
  attrs: {
    name: attr(),
    priceWith: attr(),
    priceWithout: attr(),
    isElementary: attr(),
    // ⚠️ ONE COLUMN, TWO NAMES. `onGiftsPage` says what it decides -- does this
    // add-on appear on the Announcements & Gifts grid. `isHoliday` is the
    // database column's original name, kept because carts and sheets built
    // before the rename still carry it (see DisplayableSheet, CartItem
    // DetailedView) and a customer's already-loaded page still sends it.
    isHoliday: attr(),
    onGiftsPage: attr(),
    isSenior: attr(),
    popup: attr(),
    cssName: attr(),
    createdAt: attr(),
    updatedAt: attr(),
    imageCount: attr(),
    component: belongsTo(),
    description: attr(),
    tagline: attr(),
    quantity: attr(),
    imageUrl: attr(),
    backImageUrl: attr(),
    blankImageUrl: attr(),
    horizImageUrl: attr(),
    backgroundSelection: attr(),
  },
});

export default Addon;
